const maskPhoneInput = (value: string) => {
    const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    if (x) {
      return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
    }
    return ''
  }

export {
    maskPhoneInput
}

export const US_PHONE_LEN = 10;
